
export const myData = [
  { month: 'January', value: 150 },
  { month: 'February', value: 300 },
  { month: 'March', value: 450 },
  { month: 'April', value: 200 },
  { month: 'May', value: 600 },
  { month: 'June', value: 700 },
  { month: 'July', value: 500 },
];
const labels = myData.map(item => item.month);
const datasetValues = myData.map(item => item.value);


export const data = {
  labels,
  datasets: [
    {
      fill: true,
      label: 'Dataset 2',
      data: datasetValues,
      borderColor: 'rgb(53, 162, 235)',
      backgroundColor: 'rgba(53, 162, 235, 0.5)',
    },
  ],
};

